/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
// styles
import injectSheet from 'react-jss';
import styles from './chartcards_styles';

import {
    formatChartCardData,
    getChartCardRateDirection
} from '../../../../utils/charts';
import ChartCard from './chartcard/chartcard';


/* ========== ~~~~~~~~~~ MONETIZATION CHART CARDS ~~~~~~~~~~ ========== */
const MonetizationChartCards = injectSheet(styles)(props => {

    const [currentPosition, setCurrentPosition] = useState({x: 0, y: 0, data: {x: 0, y: 0}});
    const [hideTooltip, setHideTooltip] = useState(true);
    const sidebarOpen = useSelector(state => state.app.sidebarOpen);


    const { overview, details, status } = useSelector((state) => state.revenue);
    const { filters } = useSelector((state) => state.app);
    const changeType = filters.compareTo;

    return (
        <div className={`chartcards ${props.classes.chartcards} sidebar-${sidebarOpen ? 'open' : 'close'}`}>
            { props.charts.map(chart =>
                <ChartCard
                    isSynched={true}
                    setHideTooltip={setHideTooltip}
                    hideTooltip={hideTooltip}
                    currentPosition={currentPosition}
                    setCurrentPosition={setCurrentPosition}
                    route={chart.route}
                    data={formatChartCardData(details, chart.id)}
                    direction={getChartCardRateDirection(overview.TOTAL[`${chart.id}ChangeRate`])}
                    changeType={changeType}
                    change={overview.TOTAL[`${chart.id}ChangeRate`]}
                    title={chart.title}
                    value={overview.TOTAL[chart.id]}
                    loading={status === 'pending' ? true : false}
                    noData={(status === 'fulfilled' || status === 'rejected') && overview['TOTAL'][chart.id] === 0 ? true : false}
                    yType={chart.yType}
                />
            )}
        </div>
    )
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default MonetizationChartCards;
